/* 🤖 this file was generated by svg-to-ts */
export const siriusCloudDuotone: {
  name: 'cloud_duotone';
  data: string;
} = {
  name: 'cloud_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path opacity=".2" d="M7.5 12a7.5 7.5 0 1 1 7.5 7.5H6.75a5.25 5.25 0 1 1 0-10.5c.44 0 .877.053 1.303.16" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.317 5.38A6.75 6.75 0 0 0 8.25 12a.75.75 0 0 1-1.5 0c0-.761.105-1.515.31-2.24a4.5 4.5 0 1 0-.31 8.99H15a6.75 6.75 0 0 0 1.317-13.37ZM7.62 8.312a8.248 8.248 0 0 1 8.99-4.403A8.25 8.25 0 0 1 15 20.25H6.75a6 6 0 0 1 0-12m.87.062a6.142 6.142 0 0 0-.87-.062l.87.062Z" fill="currentColor"/></svg>`
};
